import PropTypes from 'prop-types';
import React, { Component } from 'react';
const Immutable = require('immutable');
const { HYPHEN } = require('constants/index');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');

class FundItem extends Component {
    render() {
        const account = this.props.account;
        let totalValue = HYPHEN;

        if (account.totalValue !== HYPHEN) {
             const ammountObject = Immutable.fromJS({
                amount: account.totalValue,
                currency: account.totalValueCurrency
            });

            const plainAmountObject = getPlainAmountObject(ammountObject);

            totalValue = (
                <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    language={getLanguage()}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
            )
        }

        return (
            <React.Fragment>
                <div className="dropdown-funds__account-description-left">
                    <span className="dropdown-funds__account-description-alias">{account.name}</span>
                    <span className="dropdown-funds__account-description-iban">{getLastNChars(account.account)}</span>
                </div>
                <div className="dropdown-funds__account-description-amount">
                    <FormattedText value="brokerDropdownFunds-value"/>
                    { totalValue }
                </div>
            </React.Fragment>
        );
    }
}

FundItem.propTypes = {
    account: PropTypes.object.isRequired,
};

module.exports = FundItem;